export const environment = {
  production: true,
  serverUrl: 'https://api.w4.pinbox24.com/',
  // serverUrl: 'https://api.w3.pinbox24.com/',
  androidSenderId: '988916405168',
  oneSignalAppId: '193b89fd-4b08-4a89-910c-adee9633799a'
};
